import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';

export type PostAccountShipmentsBulkArchiveVariables = {
  accountId: number;
  ids: number[];
};

/**
 * POST `/api/accounts/{account}/shipments/bulk/archive` — close (archive) shipments.
 */
export default function usePostAccountShipmentsBulkArchive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      ids,
    }: PostAccountShipmentsBulkArchiveVariables) => {
      const { api, baseURL } = getApi();
      const res = await api.post(
        `/api/accounts/${accountId}/shipments/bulk/archive`,
        { ids },
        { baseURL },
      );
      return res.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['account-shipments', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-shipment-metrics', variables.accountId],
      });
    },
  });
}
